import { AccountService } from './../../_services/account.service';
import { LookupItemVm } from './../../_models/lookupItem';
import { ApiService } from '@app/_services/api.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserShortVm, User } from '@app/_models/user';
import { Observable, of } from 'rxjs';
import { CheckableSettings } from '@progress/kendo-angular-treeview';
import { retry } from 'rxjs/operators';

@Component({
  selector: 'app-user-maintenance',
  templateUrl: './user-maintenance.component.html',
  styleUrls: ['./user-maintenance.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMaintenanceComponent implements OnInit {
  roles: LookupItemVm[];
  paServices: any[];
  users: UserShortVm[];
  selectedUser: UserShortVm;
  user: User = new User();
  loading: boolean;
  isRoleSelected = (o1: any, o2: any) => o1.id === o2.id;
  isServiceSelected = (o1: any, o2: any) => o1.id === o2.id;

  constructor(
    private apiService: ApiService,
    private accountService: AccountService
  ) {}

  private loadUsers() {
    this.apiService.getUserList().subscribe((users) => 
      {
        this.users = users;
        this.loading = false;
      });
  }

  private loadLookups() {
    this.apiService.getRoles().subscribe((roles) => (this.roles = roles));
    this.apiService.getPaServicesTree().subscribe((s) => (this.paServices = s));
  }

  enableCheck = true;
  checkChildren = true;
  checkParents = true;
  checkOnClick = false;
  checkMode: any = 'multiple';
  selectionMode: any = 'single';

  get checkableSettings(): CheckableSettings {
    return {
      checkChildren: this.checkChildren,
      checkParents: this.checkParents,
      enabled: this.enableCheck,
      mode: this.checkMode,
      checkOnClick: this.checkOnClick,
    };
  }

  userDetailsNeeded(user: UserShortVm) {
    this.apiService.getUser(user.id).subscribe((detailedUser) => {
      if (!!this.selectedUser) {
        this.selectedUser.isSelected = false;
      }
      this.selectedUser = user;
      this.selectedUser.isSelected = true;
      this.user = detailedUser;
      
      this.markUserActive(this.paServices);
      console.log(this.user);
    });
  }

  updateRole(list: any) {
    console.log(list.option.value, list.option.selected);
    this.apiService
      .updateRole(this.user.id, list.option.value.id, list.option.selected)
      .subscribe((res) => console.log(res));
  }

  updatePaService(list: any) {
    console.log(list.option.value, list.option.selected);
  }

  markUserActive(serviceList: any[]) {
    if (
      !serviceList &&
      !this.user &&
      !this.user.services &&
      this.user.services.length === 0
    )
      return;
    serviceList.forEach((svc) => {
      svc.isUserActive = !!this.user.services.find((s) => s.id === svc.id);
      if (svc.children && svc.children.length > 0) {
        this.markUserActive(svc.children);
      }
    });
  }

  onPersonalSubmit() {}

  setApproved() {
    this.user.account.approvalDate = this.user.account.isApproved
      ? new Date()
      : null;
    this.user.account.approvedBy = this.user.account.isApproved
      ? this.accountService.userValue.id
      : null;
    this.apiService
      .toggleAccountApproval(this.user.account)
      .subscribe((data) => {
        console.log(data);
      });
  }

  fetchChildren = (node: any): Observable<any[]> => {
    //Return the items collection of the parent node as children.
    return of(node.children);
  };

  hasChildren = (node: any): boolean => {
    //Check if the parent node has children.
    return node.children && node.children.length > 0;
  };

  isItemChecked = (node: any, index: string) => {
    return node.isUserActive ? 'checked' : 'none';
  };

  handleChecking(event: any) {
    const item = this.user.services.find(
      (s) => s.id === event.item.dataItem.id
    );
    if (!!item) {
      this.user.services.splice(this.user.services.indexOf(item), 1);
    } else {
      this.user.services.push(event.item.dataItem);
    }
    this.markUserActive(this.paServices);
    this.apiService
      .updatePaService(this.user.id, event.item.dataItem.id, !item)
      .subscribe((res) => console.log(res));
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadUsers();
    this.loadLookups();
  }
}
